export type PoliticaEntregaColumnKey =
  | 'col1'
  | 'col2'
  | 'col3'
  | 'col4'
  | 'col5'
  | 'col6'
  | 'col7'
  | 'col8'
  | 'col9'
  | 'col10'
  | 'col11'
  | 'col12'
  | 'col13'
  | 'col14'
  | 'col15'
  | 'col16';

export const POLITICA_ENTREGA_COLUMN_KEYS: PoliticaEntregaColumnKey[] = [
  'col1',
  'col2',
  'col3',
  'col4',
  'col5',
  'col6',
  'col7',
  'col8',
  'col9',
  'col10',
  'col11',
  'col12',
  'col13',
  'col14',
  'col15',
  'col16',
];

export type PoliticaEntregaIncoterm = 'ZO1' | 'ZO2' | 'ZF5';

export const POLITICAS_ENTREGA_INCOTERMS = ['ZO1', 'ZO2', 'ZF5'] as const satisfies readonly PoliticaEntregaIncoterm[];

export interface RegionPolitica {
  codigo: number;
  nombre: string;
}

export interface PoliticaEntregaCell {
  id: number;
  horas: string;
  centro: string;
  comuna: string;
  pallet: number;
  columnKey: PoliticaEntregaColumnKey;
}

export interface PoliticaEntregaRow {
  comuna: string;
  cells: readonly PoliticaEntregaCell[];
}

export interface PoliticaEntregaSaveCommand {
  regionCodigo: number;
  comuna: string;
  incoterms: string;
  centro: string;
  pallet: number;
  horas: string;
}
